import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

// Stato invio globale: emitSendStatus({ state: "sending"|"ok"|"error", label, pct })
export const emitSendStatus = (detail) => window.dispatchEvent(new CustomEvent("pgp-send-status", { detail }));

// Indicatore centrale dell'invio email/PEC; sparisce da solo dopo il completamento.
export default function SendStatusOverlay() {
  const [s, setS] = useState(null);
  useEffect(() => {
    let t;
    const h = (e) => {
      clearTimeout(t);
      setS(e.detail);
      if (e.detail && e.detail.state !== "sending") t = setTimeout(() => setS(null), e.detail.state === "ok" ? 2500 : 4500);
    };
    window.addEventListener("pgp-send-status", h);
    return () => { window.removeEventListener("pgp-send-status", h); clearTimeout(t); };
  }, []);
  if (!s) return null;
  const ok = s.state === "ok", err = s.state === "error";
  const color = ok ? "#10b981" : err ? "#ef4444" : "#f59e0b";
  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center pointer-events-none" data-testid="send-status-overlay">
      <div className="pointer-events-auto w-[340px] max-w-[90vw] rounded-2xl bg-white shadow-2xl border p-6 text-center animate-in fade-in zoom-in-95 duration-200" style={{ borderColor: color }}>
        <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full" style={{ background: `${color}1f`, color }}>
          {ok ? <CheckCircle2 className="h-8 w-8" /> : err ? <XCircle className="h-8 w-8" /> : <Loader2 className="h-8 w-8 animate-spin" />}
        </div>
        <div className="text-base font-semibold text-slate-900" data-testid="send-status-title">
          {ok ? (s.label || "Email inviata con successo") : err ? "Errore di invio" : "Invio in corso..."}
        </div>
        {!ok && s.label && <div className="mt-1 text-sm text-slate-600 break-words" data-testid="send-status-label">{s.label}</div>}
        {s.state === "sending" && (
          <div className="mt-4">
            <div className="h-2 w-full rounded-full bg-slate-200 overflow-hidden">
              <div className="h-full rounded-full transition-all duration-300" style={{ width: `${s.pct || 5}%`, background: color }} />
            </div>
            <div className="mt-1 text-xs font-mono text-slate-500" data-testid="send-status-pct">{s.pct || 0}%</div>
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
}
